/** Public read-only CMS/menu/footer client — shared, cached in module scope for the SPA lifetime. */
import { ref } from 'vue';

const BASE = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

export interface MenuItem { id: number; name: string; url: string; icon: string | null; sort_order: number; children: MenuItem[]; }
export interface FooterSection { id: number; section_key: string; title: string | null; section_type: string; content: any; sort_order: number; }

export const menus = ref<MenuItem[]>([]);
export const footerSections = ref<FooterSection[]>([]);
export const cmsSettings = ref<Record<string, string>>({});

let loaded = false;
export async function loadCms() {
  if (loaded) return;
  loaded = true;
  try {
    const [m, f, s] = await Promise.all([
      fetch(`${BASE}/api/menus`).then(r => r.json()),
      fetch(`${BASE}/api/footer`).then(r => r.json()),
      fetch(`${BASE}/api/cms`).then(r => r.json()),
    ]);
    menus.value = (m.items || []) as MenuItem[];
    footerSections.value = (f.items || []) as FooterSection[];
    cmsSettings.value = s.settings || {};
  } catch (e) {
    console.error('cms_load_failed', e);
  }
}
